// import { Injectable } from '@angular/core';
// import {HttpService} from '../../services/http.service';
// import {CcImageSearchImageItem, CcImageSearchQueryOptions, CcImageSearchResult} from './cc-image-search.service';
// import {Licenses} from '../../../models/licenses';
// import {CcImageSearchQuery} from '../../../models/cc-image-search-query';
// import {ExternalImageSearchApis} from '../../../config/external-image-search-api.config';
// import {IStandardizedImageSearchResults} from '../../../models/standardized-image-search-results';
// import {IImageWrapper} from '../../../models/image-wrapper';
// import { DataUrl } from 'src/utils/utils';

// /**
//  * see https://www.flickr.com/services/api/flickr.photos.licenses.getInfo.html for licenses' IDs
//  */
// const flickrLicenses = {
//   0: {
//     name: 'All Rights Reserved',
//     url: '',
//     version: ''
//   },
//   1: {
//     name: 'Attribution-NonCommercial-ShareAlike License',
//     url: 'https://creativecommons.org/licenses/by-nc-sa/2.0/',
//     version: '2.0'
//   },
//   2: {
//     name: 'Attribution-NonCommercial License',
//     url: 'https://creativecommons.org/licenses/by-nc/2.0/',
//     version: '2.0'
//   },
//   3: {
//     name: 'Attribution-NonCommercial-NoDerivs License',
//     url: 'https://creativecommons.org/licenses/by-nc-nd/2.0/',
//     version: '2.0'
//   },
//   4: {
//     name: 'Attribution License',
//     url: 'https://creativecommons.org/licenses/by/2.0/',
//     version: '2.0'
//   },
//   5: {
//     name: 'Attribution-ShareAlike License',
//     url: 'https://creativecommons.org/licenses/by-sa/2.0/',
//     version: '2.0'
//   },
//   6: {
//     name: 'Attribution-NoDerivs License',
//     url: 'https://creativecommons.org/licenses/by-nd/2.0/',
//     version: '2.0'
//   },
//   7: {
//     name: 'No known copyright restrictions',
//     url: 'https://www.flickr.com/commons/usage/',
//     version: ''
//   },
//   8: {
//     name: 'United States Government Work',
//     url: 'http://www.usa.gov/copyright.shtml',
//     version: ''
//   },
//   9: {
//     name: 'Public Domain Dedication (CC0)',
//     url: 'https://creativecommons.org/publicdomain/zero/1.0/',
//     version: '1.0'
//   },
//   10: {
//     name: 'Public Domain Mark',
//     url: 'https://creativecommons.org/publicdomain/mark/1.0/',
//     version: '1.0'
//   }
// };

// /**
//  * Parameter for a flickr query
//  */
// export interface IFlickrImageSearchQueryOptions {
//   /**
//    * Targeted widht
//    */
//   width?: number;
//   /**
//    * Targeted height
//    */
//   height?: number;
//   /**
//    * Targeted ratio
//    */
//   ratio?: number;
//   /**
//    * Targeted licenses
//    */
//   license?: Licenses[];
//   /**
//    * Targeted page of the results
//    */
//   page?: number;
// }

// /**
//  * Image result item
//  */
// export interface IFlickrPublicSearchImageItem {
//   /**
//    * License id (only present when using extras=license)
//    */
//   license?: string | number;
//   /**
//    * Internal id
//    */
//   id: string;
//   /**
//    * owner/creator/author
//    */
//   owner: string;
//   /**
//    * Some sort of secret/salt
//    */
//   secret: string;
//   /**
//    * The flickr server hosting the imgae
//    */
//   server: string;
//   /**
//    * The number of the farm the server is belonging to
//    */
//   farm: number;
//   /**
//    * Title of the image
//    */
//   title: string;
//   /**
//    * Whether the image can be seen by the public
//    */
//   ispublic: number;
//   /**
//    * Whether the image can be seen by friends of the owner
//    */
//   isfriend: number;
//   /**
//    * Whether the image can be seen by the family of the owner
//    */
//   isfamily: number;
// }

// /**
//  * Detailed info on an flickr image
//  */
// export interface IFlickrGetInfoOnImageResult {
//   /**
//    * The image
//    */
//   photo: {
//     id: string;
//     secret: string;
//     server: string;
//     farm: number;
//     dateuploaded: string;
//     isfavorite: number;
//     license: string | number;
//     safety_level: 0;
//     rotation: number;
//     originalsecret: string;
//     originalformat: string;
//     owner: {
//       nsid: string;
//       username: string;
//       realname: string;
//       location: string;
//       iconserver: string;
//       iconfarm: number;
//       path_alias: string;
//     };
//     title: {
//       _content: string;
//     };
//     description: {
//       _content: string;
//     };
//     visibility: {
//       ispublic: number;
//       isfriend: number;
//       isfamily: number;
//     };
//     dates: {
//       posted: string;
//       taken: string;
//       takengranularity: number;
//       takenunknown: number;
//       lastupdate: string;
//     };
//     views: number;
//     editability: {
//       cancomment: number;
//       canaddmeta: number;
//     };
//     publiceditability: {
//       cancomment: number;
//       canaddmeta: number;
//     };
//     usage: {
//       candownload: number;
//       canblog: number;
//       canprint: number;
//       canshare: number;
//     };
//     comments: {
//       _content: number;
//     };
//     notes: any;
//     people: {
//       haspeople: number;
//     };
//     tags: any;
//     urls: {
//       url: {
//         type: string;
//         _content: string
//       }[]
//     };
//     media: string;
//   };
//   /**
//    * meta data stats
//    */
//   stat: string;
// }

// /**
//  * Results of the search
//  */
// export interface IFlickrImageSearchResult {
//   /**
//    * Results and meta data
//    */
//   photos: {
//     page: number;
//     pages: string;
//     perpage: number;
//     total: string;
//     photo: IFlickrPublicSearchImageItem[];
//   };
//   /**
//    * Stats
//    */
//   stat: string;
// }

// /**
//  * Info about an image's size
//  */
// export interface IFlickrImageSizesSearchResult {
//   /**
//    * Available sizes
//    */
//   sizes: {
//     canblog: number;
//     canprint: number;
//     candownload: number;
//     size: IFlickrImageSizeItem[]
//   };
//   /**
//    * Additional stats
//    */
//   stat: string;
// }

// /**
//  * A singular size item
//  */
// export interface IFlickrImageSizeItem {
//   label: string;
//   width: number;
//   height: number;
//   source: string;
//   url: string;
//   media: string;
// }

// /**
//  * See https://www.flickr.com/services/api/flickr.photos.search.html
//  */
// export interface IFlickrImageSearchQuery {
//   extras?: string;
//   content_type?: number;
//   media?: string;
//   text?: string;
//   api_key: string;
//   license?: string;
//   method: 'flickr.photos.search';
//   format: 'json';
//   nojsoncallback: 1;
//   per_page?: number;
//   page?: number;
//   safe_search?: number;
// }

// /**
//  * See https://www.flickr.com/services/api/flickr.photos.getInfo.html
//  */
// export interface IFlickrInfoOnImageSearchQuery {
//   api_key: string;
//   method: 'flickr.photos.getInfo';
//   format: 'json';
//   nojsoncallback: 1;
//   photo_id: string;
// }

// /**
//  * See https://www.flickr.com/services/api/explore/flickr.photos.getSizes
//  */
// export interface IFlickrSizesOfImageSearchQuery {
//   api_key: string;
//   method: 'flickr.photos.getSizes';
//   format: 'json';
//   nojsoncallback: 1;
//   photo_id: string;
// }

// @Injectable({
//   providedIn: 'root'
// })
// /**
//  * Abstracts communication with the flickr API
//  */
// export class FlickrImageSearchService {

//   /**
//    * Makes use of the HTTPService
//    * @param _http The http service
//    */
//   constructor(
//     private _http: HttpService
//   ) { }

//   /**
//    * Query the flickr API
//    * @param query The actual query
//    * @param options Some further options
//    */
//  public async query(query: string, options?: IFlickrImageSearchQueryOptions): Promise<IFlickrImageSearchResult> {
//   const apiKey = ExternalImageSearchApis['flickr']?.publicKey;
//   if (!apiKey) {
//     throw new Error('Flickr API key is missing');
//   }

//   const allowedLicenseIds = new Set<string>();
//   const defaultIds = [4, 5, 9];

//   if (!options || !options.license || options.license.length === 0) {
//     defaultIds.forEach((id: number) => allowedLicenseIds.add(String(id)));
//   } else {
//     for (const l of options.license) {
//       allowedLicenseIds.add(String(this.licenseTypeToFlickrId(l)));
//     }
//   }

//   const queryObject: IFlickrImageSearchQuery = {
//     text: query,
//     api_key: apiKey,
//     method: 'flickr.photos.search',
//     format: 'json',
//     nojsoncallback: 1,
//     per_page: 20,
//     page: options?.page ? options.page : 1,
//     safe_search: 1,
//     content_type: 1,
//     media: 'photos',
//     extras: 'license'
//   };

//   const url =
//     ExternalImageSearchApis['flickr'].url +
//     '?' +
//     this._http.convertObjectToQueryString(queryObject);

//   const res = await this._http.get(url) as IFlickrImageSearchResult;

//   console.log('Flickr raw search response:', res);

//   if (res && res.photos && Array.isArray(res.photos.photo) && allowedLicenseIds.size > 0) {
//     res.photos.photo = res.photos.photo.filter((p: IFlickrPublicSearchImageItem) => {
//       const id = p.license;
//       return id != null ? allowedLicenseIds.has(String(id)) : true;
//     });
//   }

//   console.log('Flickr filtered photos:', res?.photos?.photo);

//   return res;
// }

//   /**
//    * Convert to standardized results
//    * @param flickrImageSearchResult The results of the query
//    * @param currentPage The result's current page
//    * @param licenses The result's licenses
//    */
//   public async convertToStandardizedApiResults(flickrImageSearchResult: IFlickrImageSearchResult, currentPage: number, licenses?: Licenses[]): Promise<IStandardizedImageSearchResults> {
//     return {
//       pageCount: Number(flickrImageSearchResult.photos.pages),
//       resultCount: Number(flickrImageSearchResult.photos.total),
//       pageCurrent: Number(flickrImageSearchResult.photos.page),
//       pageSize: flickrImageSearchResult.photos.perpage,
//       license: licenses,
//       targetApi: 'flickr',
//       results: await this.convertToImageWrapper(flickrImageSearchResult.photos.photo)
//     };
//   }

//   /**
//    * Convert the results to the internally used format that is used by the tool
//    * @param imageItems The images from the query results
//    */
//  public async convertToImageWrapper(imageItems: IFlickrPublicSearchImageItem[]): Promise<IImageWrapper[]> {
//   const apiKey = ExternalImageSearchApis['flickr']?.publicKey;
//   if (!apiKey) {
//     throw new Error('Flickr API key is missing');
//   }

//   const results = await Promise.all(
//     imageItems.map(async (imageItem): Promise<IImageWrapper> => {
//       try {
//         const infoQuery: IFlickrInfoOnImageSearchQuery = {
//           api_key: apiKey,
//           method: 'flickr.photos.getInfo',
//           format: 'json',
//           nojsoncallback: 1,
//           photo_id: imageItem.id
//         };

//         const sizesQuery: IFlickrSizesOfImageSearchQuery = {
//           api_key: apiKey,
//           method: 'flickr.photos.getSizes',
//           format: 'json',
//           nojsoncallback: 1,
//           photo_id: imageItem.id
//         };

//         const urlInfo =
//           ExternalImageSearchApis['flickr'].url +
//           '?' +
//           this._http.convertObjectToQueryString(infoQuery);

//         const urlSizes =
//           ExternalImageSearchApis['flickr'].url +
//           '?' +
//           this._http.convertObjectToQueryString(sizesQuery);

//         const imageInfo = await this._http.get(urlInfo) as IFlickrGetInfoOnImageResult;
//         const imageSizes = await this._http.get(urlSizes) as IFlickrImageSizesSearchResult;

//         const allSizes = imageSizes?.sizes?.size || [];

//         const thumbnailImage =
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Medium 640') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Medium') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Small 400') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Small') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Thumbnail') ||
//           allSizes[0];

//         const sourceImage =
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Large') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Medium 800') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Medium 640') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Medium') ||
//           allSizes.find((item: IFlickrImageSizeItem) => item.label === 'Original') ||
//           thumbnailImage ||
//           allSizes[0];

//         let owner = imageInfo?.photo?.owner?.username || imageItem.owner || '';
//         if (imageInfo?.photo?.owner?.realname) {
//           owner += ` (${imageInfo.photo.owner.realname})`;
//         }

//         const licenseId = Number(imageInfo?.photo?.license ?? imageItem.license ?? 0);
//         const flickrLicense = flickrLicenses[licenseId as keyof typeof flickrLicenses];

//         const fallbackDirectImageUrl =
//           `https://live.staticflickr.com/${imageItem.server}/${imageItem.id}_${imageItem.secret}_z.jpg`;

//         const thumbnailUrl =
//           thumbnailImage?.source || fallbackDirectImageUrl;

//         const sourceUrl =
//           sourceImage?.source || thumbnailUrl || fallbackDirectImageUrl;

//         return {
//           externalId: imageItem.id,
//           base64: new DataUrl('', '', false),
//           license: this.licenseIdToType(licenseId),
//           licenseVersion: flickrLicense ? flickrLicense.version : '',
//           licenseUrl: flickrLicense ? flickrLicense.url : '',
//           description: imageInfo?.photo?.description?._content || '',
//           title: imageInfo?.photo?.title?._content || imageItem.title || '',
//           source: sourceUrl,
//           thumbnailSource: thumbnailUrl,
//           author: owner,
//           dimension: {
//             height: sourceImage?.height || thumbnailImage?.height || 200,
//             width: sourceImage?.width || thumbnailImage?.width || 200,
//             ratio:
//               (sourceImage?.width || thumbnailImage?.width || 200) /
//               (sourceImage?.height || thumbnailImage?.height || 200)
//           },
//           origin: 'flickr'
//         };
//       } catch (error) {
//         console.error('Flickr image conversion failed for image', imageItem.id, error);

//         const fallbackDirectImageUrl =
//           `https://live.staticflickr.com/${imageItem.server}/${imageItem.id}_${imageItem.secret}_z.jpg`;

//         return {
//           externalId: imageItem.id,
//           base64: new DataUrl('', '', false),
//           license: this.licenseIdToType(Number(imageItem.license || 0)),
//           licenseVersion: '',
//           licenseUrl: '',
//           description: '',
//           title: imageItem.title || '',
//           source: fallbackDirectImageUrl,
//           thumbnailSource: fallbackDirectImageUrl,
//           author: imageItem.owner || '',
//           dimension: {
//             height: 200,
//             width: 200,
//             ratio: 1
//           },
//           origin: 'flickr'
//         };
//       }
//     })
//   );

//   console.log('Flickr wrapped results:', results);

//   return results.filter((item: IImageWrapper) => !!item.thumbnailSource || !!item.source);
// }

//   /**
//    * Convert a license by id to the proper enum
//    * @param licenseId The license
//    */
//   public licenseIdToType(licenseId: number): Licenses {
//     switch (licenseId) {
//       case 9:
//         return Licenses.CC_ZERO;
//       case 4:
//         return Licenses.CC_BY;
//       case 5:
//         return Licenses.CC_BY_SA;
//       default:
//         return Licenses.UNKNOWN;
//     }
//   }

//   /**
//    * Convert the license to an id such that flickr understand the license
//    * @param license The license to be converted to an id
//    */
//   public licenseTypeToFlickrId(license: Licenses): number {
//     switch (license) {
//       case Licenses.CC_BY: {
//         return 4;
//       }
//       case Licenses.CC_BY_SA: {
//         return 5;
//       }
//       case Licenses.CC_ZERO: {
//         return 9;
//       }
//       default: {
//         throw new Error('License not supported by CC');
//       }
//     }
//   }
// }
import { Injectable } from '@angular/core';
import {HttpService} from '../../services/http.service';
import {CcImageSearchImageItem, CcImageSearchQueryOptions, CcImageSearchResult} from './cc-image-search.service';
import {Licenses} from '../../../models/licenses';
import {CcImageSearchQuery} from '../../../models/cc-image-search-query';
import {ExternalImageSearchApis} from '../../../config/external-image-search-api.config';
import {IStandardizedImageSearchResults} from '../../../models/standardized-image-search-results';
import {IImageWrapper} from '../../../models/image-wrapper';

/**
 * see https://www.flickr.com/services/api/flickr.photos.licenses.getInfo.html for licenses' IDs
 */
const flickrLicenses = {
  0: {
    name: 'All Rights Reserved',
    url: '',
    version: ''
  },
  1: {
    name: 'Attribution-NonCommercial-ShareAlike License',
    url: 'https://creativecommons.org/licenses/by-nc-sa/2.0/',
    version: '2.0'
  },
  2: {
    name: 'Attribution-NonCommercial License',
    url: 'https://creativecommons.org/licenses/by-nc/2.0/',
    version: '2.0'
  },
  3: {
    name: 'Attribution-NonCommercial-NoDerivs License',
    url: 'https://creativecommons.org/licenses/by-nc-nd/2.0/',
    version: '2.0'
  },
  4: {
    name: 'Attribution License',
    url: 'https://creativecommons.org/licenses/by/2.0/',
    version: '2.0'
  },
  5: {
    name: 'Attribution-ShareAlike License',
    url: 'https://creativecommons.org/licenses/by-sa/2.0/',
    version: '2.0'
  },
  6: {
    name: 'Attribution-NoDerivs License',
    url: 'https://creativecommons.org/licenses/by-nd/2.0/',
    version: '2.0'
  },
  7: {
    name: 'No known copyright restrictions',
    url: 'https://www.flickr.com/commons/usage/',
    version: ''
  },
  8: {
    name: 'United States Government Work',
    url: 'http://www.usa.gov/copyright.shtml',
    version: ''
  },
  9: {
    name: 'Public Domain Dedication (CC0)',
    url: 'https://creativecommons.org/publicdomain/zero/1.0/',
    version: '1.0'
  },
  10: {
    name: 'Public Domain Mark',
    url: 'https://creativecommons.org/publicdomain/mark/1.0/',
    version: '1.0'
  }
};

/**
 * Parameter for a flickr query
 */
export interface IFlickrImageSearchQueryOptions {
  /**
   * Targeted widht
   */
  width?: number;
  /**
   * Targeted height
   */
  height?: number;
  /**
   * Targeted ratio
   */
  ratio?: number;
  /**
   * Targeted licenses
   */
  license?: Licenses[];
  /**
   * Targeted page of the results
   */
  page?: number;
}

/**
 * Image result item
 */
export interface IFlickrPublicSearchImageItem {
  /**
   * Internal id
   */
  id: string;
  /**
   * owner/creator/author
   */
  owner: string;
  /**
   * Some sort of secret/salt
   */
  secret: string;
  /**
   * The flickr server hosting the imgae
   */
  server: string;
  /**
   * The number of the farm the server is belonging to
   */
  farm: number;
  /**
   * Title of the image
   */
  title: string;
  /**
   * Whether the image can be seen by the public
   */
  ispublic: number;
  /**
   * Whether the image can be seen by friends of the owner
   */
  isfriend: number;
  /**
   * Whether the image can be seen by the family of the owner
   */
  isfamily: number;
}

/**
 * Detailed info on an flickr image
 */
export interface IFlickrGetInfoOnImageResult {
  /**
   * The image
   */
  photo: {
    id: string;
    secret: string;
    server: string;
    farm: number;
    dateuploaded: string;
    isfavorite: number;
    license: string | number;
    safety_level: 0;
    rotation: number;
    originalsecret: string;
    originalformat: string;
    owner: {
      nsid: string;
      username: string;
      realname: string;
      location: string;
      iconserver: string;
      iconfarm: number;
      path_alias: string;
    };
    title: {
      _content: string;
    };
    description: {
      _content: string;
    };
    visibility: {
      ispublic: number;
      isfriend: number;
      isfamily: number;
    };
    dates: {
      posted: string;
      taken: string;
      takengranularity: number;
      takenunknown: number;
      lastupdate: string;
    };
    views: number;
    editability: {
      cancomment: number;
      canaddmeta: number;
    };
    publiceditability: {
      cancomment: number;
      canaddmeta: number;
    };
    usage: {
      candownload: number;
      canblog: number;
      canprint: number;
      canshare: number;
    };
    comments: {
      _content: number;
    };
    notes: any;
    people: {
      haspeople: number;
    };
    tags: any;
    urls: {
      url: {
        type: string;
        _content: string
      }[]
    };
    media: string;
  };
  /**
   * meta data stats
   */
  stat: string;
}

/**
 * Results of the search
 */
export interface IFlickrImageSearchResult {
  /**
   * Results and meta data
   */
  photos: {
    page: number;
    pages: string;
    perpage: number;
    total: string;
    photo: IFlickrPublicSearchImageItem[];
  };
  /**
   * Stats
   */
  stat: string;
}

/**
 * Info about an image's size
 */
export interface IFlickrImageSizesSearchResult {
  /**
   * Available sizes
   */
  sizes: {
    canblog: number;
    canprint: number;
    candownload: number;
    size: IFlickrImageSizeItem[]
  };
  /**
   * Additional stats
   */
  stat: string;
}

/**
 * A singular size item
 */
export interface IFlickrImageSizeItem {
  label: string;
  width: number;
  height: number;
  source: string;
  url: string;
  media: string;
}

/**
 * See https://www.flickr.com/services/api/flickr.photos.search.html
 */
export interface IFlickrImageSearchQuery {
  text?: string;
  api_key: string;
  license?: string;
  method: 'flickr.photos.search';
  format: 'json';
  nojsoncallback: 1;
  per_page?: number;
  page?: number;
  safe_search?: number;
}

/**
 * See https://www.flickr.com/services/api/flickr.photos.getInfo.html
 */
export interface IFlickrInfoOnImageSearchQuery {
  api_key: string;
  method: 'flickr.photos.getInfo';
  format: 'json';
  nojsoncallback: 1;
  photo_id: string;
}

/**
 * See https://www.flickr.com/services/api/explore/flickr.photos.getSizes
 */
export interface IFlickrSizesOfImageSearchQuery {
  api_key: string;
  method: 'flickr.photos.getSizes';
  format: 'json';
  nojsoncallback: 1;
  photo_id: string;
}

@Injectable({
  providedIn: 'root'
})
/**
 * Abstracts communication with the flickr API
 */
export class FlickrImageSearchService {

  /**
   * Makes use of the HTTPService
   * @param _http The http service
   */
  constructor(
    private _http: HttpService
  ) { }

  /**
   * Query the flickr API
   * @param query The actual query
   * @param options Some further options
   */
  public async query(query: string, options?: IFlickrImageSearchQueryOptions): Promise<IFlickrImageSearchResult> {
    // this is the query object that will be sent to the API
    const _queryObject: IFlickrImageSearchQuery = {
      text: query,
      api_key: ExternalImageSearchApis['flickr'].publicKey,
      method: 'flickr.photos.search',
      format: 'json',
      nojsoncallback: 1,
      per_page: 20,
      page: (options && options.page) ? options.page : 1,
      safe_search: 3
    };
    if (!options || !options.license || options.license.length === 0) {
      _queryObject.license = '4,5,9';
    } else {
      let _convertedLicenses: string = '';
      for (const license of options.license) {
        // we glue the converted licenses together since the API expects a comma separated string, not an array
        _convertedLicenses += this.licenseTypeToFlickrId(license) + ',';
      }
      _convertedLicenses = _convertedLicenses.slice(0, _convertedLicenses.length - 1);
      _queryObject.license = _convertedLicenses;
    }

    const url = ExternalImageSearchApis['flickr'].url + '?' + this._http.convertObjectToQueryString(_queryObject);
    return this._http.get(url);

  }

  /**
   * Convert to standardized results
   * @param flickrImageSearchResult The results of the query
   * @param currentPage The result's current page
   * @param licenses The result's licenses
   */
  public async convertToStandardizedApiResults(flickrImageSearchResult: IFlickrImageSearchResult, currentPage: number, licenses?: Licenses[]): Promise<IStandardizedImageSearchResults> {
    return {
      pageCount: Number(flickrImageSearchResult.photos.pages),
      resultCount: Number(flickrImageSearchResult.photos.total),
      pageCurrent: Number(flickrImageSearchResult.photos.page),
      pageSize: flickrImageSearchResult.photos.perpage,
      license: licenses,
      targetApi: 'flickr',
      results: await this.convertToImageWrapper(flickrImageSearchResult.photos.photo)
    };
  }

  /**
   * Convert the results to the internally used format that is used by the tool
   * @param imageItems The images from the query results
   */
  public async convertToImageWrapper(imageItems: IFlickrPublicSearchImageItem[]): Promise<IImageWrapper[]> {
    const results: IImageWrapper[] = [];
    for (const imageItem of imageItems) {
      // get additional info on the image
      const _queryObjectInfo: IFlickrInfoOnImageSearchQuery = {
        api_key: ExternalImageSearchApis['flickr'].publicKey,
        method: 'flickr.photos.getInfo',
        format: 'json',
        nojsoncallback: 1,
        photo_id: imageItem.id
      };

      let singleResult : IImageWrapper = {
        externalId: imageItem.id,
        base64: null,
        // license: this.licenseIdToType(Number(imageInfo.photo.license)),
        // licenseVersion: flickrLicenses[imageInfo.photo.license].version,
        // licenseUrl: flickrLicenses[imageInfo.photo.license].url,
        // description: imageInfo.photo.description._content,
        // title: imageInfo.photo.title._content,
        // source: _refOriginalImage.source,
        thumbnailSource: 'assets/image-placeholder.svg',
        // author: _owner,
        dimension: {
          height: 200,
          width: 200,
          ratio: 1
        },
        origin: 'flickr'
      };
      results.push(singleResult);

      const urlInfo = ExternalImageSearchApis['flickr'].url + '?' + this._http.convertObjectToQueryString(_queryObjectInfo);

      this._http.get(urlInfo).then((imageInfo : IFlickrGetInfoOnImageResult) => {
        let _owner = imageInfo.photo.owner.username;
        if (imageInfo.photo.owner.realname && imageInfo.photo.owner.realname !== '') {
          _owner += ` (${imageInfo.photo.owner.realname})`;
        }
        // Info loaded


        singleResult.license = this.licenseIdToType(Number(imageInfo.photo.license));
        singleResult.licenseVersion = flickrLicenses[imageInfo.photo.license].version;
        singleResult.licenseUrl = flickrLicenses[imageInfo.photo.license].url;
        singleResult.description = imageInfo.photo.description._content;
        singleResult.title = imageInfo.photo.title._content;
        singleResult.author = _owner;
      });
      // get info on the size and the url of the original
      const _queryObjectSizes: IFlickrSizesOfImageSearchQuery = {
        api_key: ExternalImageSearchApis['flickr'].publicKey,
        method: 'flickr.photos.getSizes',
        format: 'json',
        nojsoncallback: 1,
        photo_id: imageItem.id
      };

        const urlSizes = ExternalImageSearchApis['flickr'].url + '?' + this._http.convertObjectToQueryString(_queryObjectSizes);
        // the original size seems to always be the last item, and the thumbnails seems to always be the third, but for safety's sake
        // we'll loop through the sizes and check the label
        // Read from top to bottom, if a size does note exist (maybe because the original is already small) then the next smaller
        // size will be used as thumbnail. The image labelled 'Thumbnail' should always exist
        const sizesForThumbnail = [
          'Medium 800',
          'Medium 640',
          'Medium',
          'Small 400',
          'Small 320',
          'Small',
          'Thumbnail'
        ];

      this._http.get(urlSizes).then((imageSizes: IFlickrImageSizesSearchResult) => {
        let _refThumbnailImage: IFlickrImageSizeItem | undefined;
        for (const size of sizesForThumbnail) {
          _refThumbnailImage = imageSizes.sizes.size.find((item: IFlickrImageSizeItem) => item.label === size);
          if (_refThumbnailImage != null) { break; }
        }
        // Thumbnail loaded:
        singleResult.thumbnailSource = _refThumbnailImage?.source || 'assets/image-placeholder.svg';

        const _refOriginalImage: IFlickrImageSizeItem =
          imageSizes.sizes.size.find((item: IFlickrImageSizeItem) => item.label === 'Original');
        // Using  'Original' often causes problems bc many images on flickr are really huge (>> 5000 x 3000)
        // Thus, for now lets use size `Large` as source, as long as it is available (fallback to original source)
        let largeSize = imageSizes.sizes.size.find((item: IFlickrImageSizeItem) => item.label === 'Large');
        console.log({largeSize});
        singleResult.source = largeSize ? largeSize.source : _refOriginalImage.source;
        let usedImg = largeSize ? largeSize : _refOriginalImage;
        // ImageSize loaded:
        singleResult.dimension = {
                                  height: usedImg.height,
                                  width: usedImg.width,
                                  ratio: usedImg.width / usedImg.height
                                }

      });

    }
    return results;
  }

  /**
   * Convert a license by id to the proper enum
   * @param licenseId The license
   */
  public licenseIdToType(licenseId: number): Licenses {
    switch (licenseId) {
      case 9:
        return Licenses.CC_ZERO;
      case 4:
        return Licenses.CC_BY;
      case 5:
        return Licenses.CC_BY_SA;
      default:
        return Licenses.UNKNOWN;
    }
  }

  /**
   * Convert the license to an id such that flickr understand the license
   * @param license The license to be converted to an id
   */
  public licenseTypeToFlickrId(license: Licenses): number {
    switch (license) {
      case Licenses.CC_BY: {
        return 4;
      }
      case Licenses.CC_BY_SA: {
        return 5;
      }
      case Licenses.CC_ZERO: {
        return 9;
      }
      default: {
        throw new Error('License not supported by CC');
      }
    }
  }
}
